
import { component } from '@/helpers/vueTyped';
import store, { dispatch } from '@/store';
import { TournamentSport } from './types';
import TournamentSelectContainer from './TournamentSelect/TournamentSelectContainer.vue';
import WithNavigateOnFocus from '@/components/Helpers/WithNavigateOnFocus.vue';
import { getTournamentContextTabs, SportTab, getSportContextTabs } from '@/helpers/sports';

interface ContextMenuProps {
  selectOptions: TournamentSport;
}

export default component<ContextMenuProps>()({
  name: 'ContextMenu',

  data() {
    return {
      lastFocusedMenuItem: undefined as HTMLElement | undefined,
    };
  },

  props: {
    selectOptions: {},
  },

  computed: {
    hasTournaments(): boolean {
      return (
        (this.selectOptions && this.selectOptions.groups.length > 0) ||
        (this.selectOptions && this.selectOptions.tournaments.length > 0)
      );
    },

    classificationCheck(): boolean {
      switch (store.state.selectedTournament.classification) {
        case 'sport':
        case undefined:
        case null:
          return false;
        default:
          return true;
      }
    },

    sportTournamentRoute(): string {
      const { sport, tournament } = store.state.navigationState;

      return `/${sport}/${tournament}`;
    },

    tabs(): SportTab[] {
      return [
        ...[
          { name: 'Video', path: 'videos' },
          { name: 'News', path: 'news' },
        ],
        ...this.classificationCheck
          ? [...getSportContextTabs(), ...getTournamentContextTabs()]
          : getSportContextTabs(),
      ];
    },
  },

  methods: {
    setLastItemFocused(event: FocusEvent): void {
      this.lastFocusedMenuItem = event.target as HTMLElement;
    },

    focus(): void {
      dispatch('setDrawerHidden', [false]);

      if (this.lastFocusedMenuItem) {
        this.lastFocusedMenuItem.focus();
      } else if (this.$refs.tournamentselect) {
        ((this.$refs.tournamentselect as Vue).$el as HTMLElement).focus();
      } else {
        ((this.$refs.video as Vue).$el as HTMLElement).focus();
      }
    },

    isSelected(ref: string): boolean {
      return (
        Boolean(this.lastFocusedMenuItem) &&
        this.lastFocusedMenuItem === (this.$refs[ref] as Vue)?.$el
      );
    },
  },

  watch: {
    sportTournamentRoute(): void {
      this.lastFocusedMenuItem = undefined;
    },
  },

  render() {
    const { selectOptions, hasTournaments, classificationCheck, $attrs } = this;

    if (!hasTournaments) {
      return <div key='empty' class='context-menu' />;
    }

    return (
      <div
        key='context-menu'
        v-spatial-container
        onFocus={this.focus}
        class='context-menu'
      >
        <div ref='tabs' class='tournament-only-menus'>
          <TournamentSelectContainer
            v-spatial-element='contextMenu'
            nativeOnFocus={this.setLastItemFocused}
            class={[
              'context-item',
              this.isSelected('tournamentselect') ? 'is-selected' : '',
            ]}
            ref='tournamentselect'
            options={selectOptions}
            closeCallback={this.focus}
          />

          {this.tabs.map((tab) => (
            <WithNavigateOnFocus
              ref={tab.path}
              v-spatial-element='contextMenu'
              nativeOnFocus={this.setLastItemFocused}
              class={[
                'context-item',
                this.isSelected(tab.path) ? 'is-selected' : '',
              ]}
              to={{ name: tab.path }}
              attrs={$attrs}
            >
              <div>{tab.name}</div>
            </WithNavigateOnFocus>
          ))}
        </div>
      </div>
    );
  },
});

// VUE JSX HOT LOADER //
if (module.hot) require("/github/workspace/node_modules/vue-jsx-hot-loader/src/api.js")({ Vue: require('vue'), ctx: eval('this'), module: module, hotId: "_vue_jsx_hot-32cc42ec/ContextMenu.vue" });